module.exports = __webpack_public_path__ + "img/felix_gumbsch_6.da917bfa.jpg";